import script from "./HrWorkforceLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./HrWorkforceLegend.vue?vue&type=script&setup=true&lang=js"

import "./hrWorkforce.css?vue&type=style&index=0&id=5960d174&scoped=true&lang=css"
import "./HrWorkforceLegend.vue?vue&type=style&index=1&id=5960d174&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5960d174"]])

export default __exports__